import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// In addition we need to pass in the number of pages.

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SearchFilterMenu from './SearchFilterMenu';
import SearchResultContainer from './SearchResultContainer';
import { INITIAL_STATE } from './SearchFilterMenu/constants';
var filterParams = function filterParams(res) {
  var isArray = Array.isArray(res);
  if (isArray && res.length > 0) return JSON.stringify(res);
  if (isArray && !(res.length > 0) || !res) return '';
  return res;
};
var convertStateToParams = function convertStateToParams(params, currentPage) {
  var paramsCopy = Object.entries(params).map(function (entry) {
    return Object.entries(entry[1]);
  });
  var convertedParams = paramsCopy.reduce(function (prev, curr) {
    var dict = _objectSpread({}, prev);
    for (var i = 0, ii = curr.length; i < ii; i += 1) {
      dict[curr[i][0]] = filterParams(curr[i][1]);
    }
    return dict;
  }, {});
  return _objectSpread(_objectSpread({}, convertedParams), {}, {
    page: currentPage,
    format: 'json'
  });
};
var convertParamsToUrl = function convertParamsToUrl(params) {
  var paramArray = Object.entries(params);
  var url = '/search?';
  for (var i = 0, ii = paramArray.length; i < ii; i += 1) {
    var withoutSpace = paramArray[i][0].replace(/ /g, '+');
    if (i === 0 && paramArray[i][0] !== 'format') {
      url += "".concat(withoutSpace, "=").concat(paramArray[i][1]);
    } else if (paramArray[i][0] !== 'format') {
      url += "&".concat(withoutSpace, "=").concat(paramArray[i][1]);
    }
  }
  return url;
};
var SearchContainer = /*#__PURE__*/function (_PureComponent) {
  function SearchContainer(props) {
    var _this;
    _classCallCheck(this, SearchContainer);
    _this = _callSuper(this, SearchContainer, [props]);
    _this.state = {
      searchTriggered: false,
      consultants: props.consultants,
      queryId: props.query,
      totalResults: props.totalResults,
      currentPage: 1,
      totalPages: props.totalPages,
      params: INITIAL_STATE.selections
    };
    _this.setSelectionState = _this.setSelectionState.bind(_this);
    _this.handleParamChange = _this.handleParamChange.bind(_this);
    _this.handleConsultantFetch = _this.handleConsultantFetch.bind(_this);
    _this.handleConsultantChange = _this.handleConsultantChange.bind(_this);
    _this.setWindowUrlParams = _this.setWindowUrlParams.bind(_this);
    _this.clearParams = _this.clearParams.bind(_this);
    _this.setCurrentPage = _this.setCurrentPage.bind(_this);
    return _this;
  }
  _inherits(SearchContainer, _PureComponent);
  return _createClass(SearchContainer, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$state = this.state,
        params = _this$state.params,
        currentPage = _this$state.currentPage;
      this.setState({
        params: convertStateToParams(params, currentPage)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_prevProps, prevState) {
        var searchTriggered;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              searchTriggered = this.state.searchTriggered;
              if (!(searchTriggered !== prevState.searchTriggered && searchTriggered)) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return this.handleConsultantFetch();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidUpdate(_x, _x2) {
        return _componentDidUpdate.apply(this, arguments);
      }
      return componentDidUpdate;
    }()
  }, {
    key: "setCurrentPage",
    value: function setCurrentPage(currentPage) {
      var _this2 = this;
      this.setState({
        currentPage: currentPage
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.handleConsultantFetch();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, {
    key: "setSelectionState",
    value: function setSelectionState(params) {
      var currentPage = this.state.currentPage;
      this.setState({
        searchTriggered: true,
        params: convertStateToParams(params, currentPage)
      });
    }
  }, {
    key: "setWindowUrlParams",
    value: function setWindowUrlParams() {
      var params = this.state.params;
      window.history.pushState({
        path: window.location.pathname
      }, '', convertParamsToUrl(params));
    }
  }, {
    key: "clearParams",
    value: function clearParams() {
      var _this3 = this;
      this.setState({
        params: convertStateToParams(INITIAL_STATE.selections, 1),
        searchTriggered: true
      }, function () {
        _this3.setWindowUrlParams();
      });
    }
  }, {
    key: "handleParamChange",
    value: function handleParamChange(newParams) {
      this.setState({
        params: newParams,
        searchTriggered: true
      });
    }
  }, {
    key: "handleConsultantFetch",
    value: function () {
      var _handleConsultantFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$state2, params, currentPage, resultsHash, consultants, totalResults, queryId, totalPages;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$state2 = this.state, params = _this$state2.params, currentPage = _this$state2.currentPage;
              _context3.next = 3;
              return this.constructor.getConsultants(params, currentPage);
            case 3:
              resultsHash = _context3.sent;
              consultants = resultsHash.consultants, totalResults = resultsHash.totalResults, queryId = resultsHash.queryId, totalPages = resultsHash.totalPages;
              this.handleConsultantChange(consultants, totalResults, queryId, totalPages);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleConsultantFetch() {
        return _handleConsultantFetch.apply(this, arguments);
      }
      return handleConsultantFetch;
    }()
  }, {
    key: "handleConsultantChange",
    value: function handleConsultantChange(consultants, totalResults, queryId, totalPages) {
      var _this4 = this;
      this.setState({
        consultants: consultants,
        totalResults: totalResults,
        queryId: queryId,
        totalPages: totalPages,
        currentPage: 1,
        searchTriggered: false
      }, function () {
        return _this4.setWindowUrlParams();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
        searchTriggered = _this$state3.searchTriggered,
        consultants = _this$state3.consultants,
        totalResults = _this$state3.totalResults,
        queryId = _this$state3.queryId,
        currentPage = _this$state3.currentPage,
        totalPages = _this$state3.totalPages;
      var _this$props = this.props,
        location = _this$props.location,
        csrfToken = _this$props.csrfToken,
        workLocationOptions = _this$props.workLocationOptions,
        durationOptions = _this$props.durationOptions,
        timePerWeekOptions = _this$props.timePerWeekOptions,
        inviteUrl = _this$props.inviteUrl,
        inviterEmailDomain = _this$props.inviterEmailDomain,
        viewingAsEmployer = _this$props.viewingAsEmployer;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-none d-md-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-4 col-md-5 col-sm-12 col-xs-12"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header"
      }, "Search for consultants")), /*#__PURE__*/React.createElement("div", {
        className: "tabs"
      }, /*#__PURE__*/React.createElement("a", {
        className: "tab-active body-text-2 toggle-all-talents-tab tab",
        role: "button",
        href: "/search"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-users"
      }), "All Talents"), /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 toggle-saved-tab tab",
        role: "button",
        href: "/search/saved"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-heart"
      }), "Saved"))), /*#__PURE__*/React.createElement("div", {
        className: "d-block d-md-none"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-8 col-md-7 col-sm-12 col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tabs"
      }, /*#__PURE__*/React.createElement(SearchFilterMenu, _extends({}, this.props, {
        setSelectionState: this.setSelectionState,
        clearParams: this.clearParams
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-4 col-md-5 col-sm-12 col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mobile-header mt-3"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mobile-cta"
      }, "Search consultants"), /*#__PURE__*/React.createElement("button", {
        className: "btn search-filter-button",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#collapseFilters",
        "aria-expanded": "false",
        "aria-controls": "collapseFilters"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-filter me-2"
      }), "Filter")), /*#__PURE__*/React.createElement("hr", {
        className: "mt-3"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-none d-md-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "left-panel col-lg-4 col-md-5 col-sm-12 col-xs-12"
      }, /*#__PURE__*/React.createElement(SearchFilterMenu, _extends({}, this.props, {
        setSelectionState: this.setSelectionState,
        clearParams: this.clearParams
      })))), /*#__PURE__*/React.createElement("div", {
        className: "d-block d-md-none"
      }, /*#__PURE__*/React.createElement("div", {
        className: "collapse left-panel col-lg-4 col-md-5 col-sm-12 col-xs-12",
        id: "collapseFilters"
      }, totalResults > 0 && /*#__PURE__*/React.createElement("div", {
        className: "total-results body-text-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "medium-weight"
      }, totalResults, ' ', "consultants matching your criteria")), /*#__PURE__*/React.createElement(SearchResultContainer, {
        loading: searchTriggered,
        consultants: consultants,
        location: location,
        csrfToken: csrfToken,
        workLocationOptions: workLocationOptions,
        durationOptions: durationOptions,
        timePerWeekOptions: timePerWeekOptions,
        query: queryId,
        inviteUrl: inviteUrl,
        inviterEmailDomain: inviterEmailDomain,
        currentPage: currentPage,
        setCurrentPage: this.setCurrentPage,
        viewingAsEmployer: viewingAsEmployer,
        totalPages: totalPages
      }))), /*#__PURE__*/React.createElement("div", {
        className: "right-panel col-lg-8 col-md-7 col-sm-12 col-xs-12"
      }, totalResults > 0 && /*#__PURE__*/React.createElement("div", {
        className: "total-results body-text-2"
      }, /*#__PURE__*/React.createElement("span", {
        className: "medium-weight"
      }, totalResults, ' ', "consultants matching your criteria")), /*#__PURE__*/React.createElement(SearchResultContainer, {
        loading: searchTriggered,
        consultants: consultants,
        location: location,
        csrfToken: csrfToken,
        workLocationOptions: workLocationOptions,
        durationOptions: durationOptions,
        timePerWeekOptions: timePerWeekOptions,
        query: queryId,
        inviteUrl: inviteUrl,
        inviterEmailDomain: inviterEmailDomain,
        currentPage: currentPage,
        setCurrentPage: this.setCurrentPage,
        viewingAsEmployer: viewingAsEmployer,
        totalPages: totalPages
      }))));
    }
  }], [{
    key: "getConsultants",
    value: (/* eslint no-param-reassign: ["error", { "props": false }] */function () {
      var _getConsultants = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params, currentPage) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params.page = currentPage;
              _context4.next = 3;
              return axios.get('/search', {
                params: params
              });
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", {
                consultants: response.data.consultants,
                totalResults: response.data.total_results,
                queryId: response.data.query,
                totalPages: response.data.total_pages
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getConsultants(_x3, _x4) {
        return _getConsultants.apply(this, arguments);
      }
      return getConsultants;
    }())
  }]);
}(PureComponent);
SearchContainer.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  workLocationOptions: PropTypes.shape({}).isRequired,
  durationOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]).isRequired,
  timePerWeekOptions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]).isRequired,
  query: PropTypes.number,
  inviteUrl: PropTypes.string.isRequired,
  inviterEmailDomain: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  viewingAsEmployer: PropTypes.bool,
  consultants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  totalResults: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired
};
SearchContainer.defaultProps = {
  query: '',
  viewingAsEmployer: true
};
export default SearchContainer;